import styled, { css } from 'styled-components';
import mq from 'UIKit/Mq';
import { colors } from '../../theme';

const Panel = styled.div.attrs(props => ({
  className: props.className,
  style: props.style,
}))`
  position: relative;
  min-height: 100%;
  width: 100%;
  border-radius: 10px;
  //box-shadow: 3px 3px 7px 5px rgba(0, 0, 0, 0.1);
  background-color: ${colors.gray};
  display: flex;
  flex-direction: column;
  padding: 30px;
  ${css`
    ${mq.tabletHorizontal`
      	    padding: 20px;
      `};
  `},
`;

export default Panel;
